import { HTMLProps } from 'react'

export function IconInfo({ className, ...props }: HTMLProps<SVGSVGElement>) {
    return (
        <svg className={className} {...props}>
            <use href={`#icon-info`} />
        </svg>
    )
}